import React, {memo, useCallback, useEffect, useRef, useState} from "react"
import iconFailure from "../../assets/images/icons/pop-up/cancel.png"
import iconSuccess from "../../assets/images/icons/pop-up/ok.png"
import {closeAlarmPasswordPopupScreenAction} from "../../store/ui/actions"
import {useDispatch, useSelector} from "react-redux"
import {onClickHandler} from "../../utils/onclick"
import {useLocalization} from "../../hooks/localization"
import {useKeyboard} from "../../hooks/keyboard"
import {useRPC} from "../../hooks/rpc"
import {setPasswordActionV2} from "../../store/control/actions"
import {useOutsideDetector} from "../../hooks/outside-detector"
import {useOrientation} from "../../hooks/orientation"
import "./index.scss"

export const PopupPasswordScreen = memo(function PopupPasswordScreen() {
    const dispatch = useDispatch()
    const popupAlarmPasswordState = useSelector(state => state.ui.popupAlarmPasswordState)
    const currentAlarmPassword = useSelector(state => state.control.passwordStatusV2)
    const orientation = useOrientation()
    const centerAreaRef = useOutsideDetector(!popupAlarmPasswordState.closable, () => {
        dispatch(closeAlarmPasswordPopupScreenAction())
    })
    const [passwordStatusCheck, setPasswordStatusCheck] = useState(false)

    let {callback} = popupAlarmPasswordState
    const {t} = useLocalization()
    const [rpc] = useRPC()
    const alarmPasswordRef = useRef<HTMLInputElement>()
    const [setActivePassword, renderNumpad] = useKeyboard("numpad", true)
    const [alarmPassword, setAlarmPassword] = useState("")
    const onFocusAlarmPassword = useCallback(
        () => setActivePassword([alarmPasswordRef, alarmPassword, setAlarmPassword]),
        [alarmPassword, setActivePassword]
    )
    const onBlur = useCallback(() => setActivePassword(null), [setActivePassword])
    const answer = useCallback(
        (isApproved: boolean) => {
            dispatch(closeAlarmPasswordPopupScreenAction())
            if (callback) {
                callback(isApproved)
            }
        },
        [dispatch, callback]
    )
    useEffect(() => {
        if (alarmPassword.length === 4) {
            rpc.checkAlarmPasswordV2(alarmPassword)
        }
    }, [rpc, alarmPassword])
    const onPositiveButtonClick = useCallback(() => {
        rpc.checkAlarmPasswordV2(alarmPassword).then(() => {
            if (currentAlarmPassword) {
                dispatch(setPasswordActionV2(null))
                setPasswordStatusCheck(false)
                return answer(true)
            } else {
                setPasswordStatusCheck(true)
            }
        })
    }, [answer, dispatch, rpc, alarmPassword, currentAlarmPassword])

    const onCancelClick = useCallback(() => {
        dispatch(closeAlarmPasswordPopupScreenAction())
    }, [dispatch])
    return (
        <div className={"popup-alarm-password-container " + orientation}>
            <div className="popup-alarm-password" ref={centerAreaRef}>
                <input
                    autoComplete="new-password"
                    type="password"
                    maxLength={4}
                    placeholder={t("alarm_password")}
                    ref={alarmPasswordRef}
                    onChange={e => setAlarmPassword(e.target.value)}
                    className="popup-alarm-input-button"
                    onFocus={onFocusAlarmPassword}
                    onBlur={onBlur}
                    value={alarmPassword}
                />
                <span>{passwordStatusCheck ? t("wrong_password") : ""}</span>
                <div className="popup-alarm-input-button-container">
                    <button className="popup-alarm-button" {...onClickHandler(onPositiveButtonClick)}>
                        <img src={iconSuccess} alt="" />
                        <span>{t("approve")}</span>
                    </button>
                    <button className="popup-alarm-button" {...onClickHandler(onCancelClick)}>
                        <img src={iconFailure} alt="" />
                        <span>{t("cancel")}</span>
                    </button>
                </div>
            </div>
            {renderNumpad()}
        </div>
    )
})
